import { Component, OnInit } from '@angular/core';
import { LicenseGeneralFeature, LicenseProductType, LicenseService, LicenseTestFeature } from '@isophi/core-legacy';
import { Material } from '@isophi/teachers-shared';
import { combineLatest, Observable } from 'rxjs';

import { KindergartenService } from '../../../../core/services/kindergarten.service';
import { DashboardService } from '../../services/dashboard.service';
import { MaterialService } from '../../services/material.service';

@Component({
    selector: 'app-manuals',
    templateUrl: './manuals.component.html',
    styleUrls: ['./manuals.component.scss'],
    standalone: false
})
export class ManualsComponent implements OnInit {
  licenses$: Observable<Record<string, boolean>>;

  manualData$: Observable<Material[]>;

  manualProductsVideo$: Observable<string[]>;

  constructor(
    private licenseService: LicenseService,
    protected materialService: MaterialService,
    protected dashboardService: DashboardService,
    private kindergartenService: KindergartenService
  ) {}

  ngOnInit(): void {
    this.initLicenses();
    this.manualData$ = this.materialService.getManualMaterials();
    this.manualProductsVideo$ = this.dashboardService.getVideoManuals();
  }

  isKindergarten(): boolean {
    return this.kindergartenService.loggedKindergarten.orgType.some((orgType) => orgType.orgType === "KINDERGARTEN");
  }

  /**
  * Init licenses for this component.
  */
  private initLicenses(): void {
    this.licenses$ = combineLatest({
      generalSupport: this.licenseService.hasAnyProductWithFeature(LicenseProductType.GENERAL, LicenseGeneralFeature.GENERAL_SUPPORT),
      testSupport: this.licenseService.hasAnyProductWithFeature(LicenseProductType.TEST, LicenseTestFeature.TEST_SUPPORT),
      testSupportVideo: this.licenseService.hasAnyProductWithFeature(LicenseProductType.TEST, LicenseTestFeature.TEST_SUPPORT_VIDEO),
      testSupportZ: this.licenseService.hasAnyProductWithFeature(LicenseProductType.TEST_Z, LicenseTestFeature.TEST_SUPPORT),
      testSupportVideoZ: this.licenseService.hasAnyProductWithFeature(LicenseProductType.TEST_Z, LicenseTestFeature.TEST_SUPPORT_VIDEO),
      testSupportD3to4: this.licenseService.hasProductWithFeature('test_3-4', LicenseTestFeature.TEST_SUPPORT),
      testSupportD4to5: this.licenseService.hasProductWithFeature('test_4-5', LicenseTestFeature.TEST_SUPPORT),
      testSupportD5to7v1: this.licenseService.hasProductWithFeature('test_5-7_v1', LicenseTestFeature.TEST_SUPPORT),
      testSupportD5to7v2: this.licenseService.hasProductWithFeature('test_5-7_v2', LicenseTestFeature.TEST_SUPPORT),
      testSupportD5to7SK: this.licenseService.hasProductWithFeature('test_5-7_sk_v2', LicenseTestFeature.TEST_SUPPORT)
    });
  }
}
